<template>
	<v-dialog
		v-model="showDialog"
		persistent
		content-class="manage-field-dialog"
		scrollable
		width="800px"
	>
		<v-card>
			<v-card-title>
				Manage fields
				<v-card-subtitle>
					<span>Drag the handle ( </span>
					<span
						><v-icon
							small
							color="primary"
							style="position: relative; top: 0; right: 0"
							>mdi-reorder-horizontal</v-icon
						></span
					>
					<span> ) to change the order of the columns.</span>
				</v-card-subtitle>
			</v-card-title>

			<v-card-text class="pa-0">
				<div class="search-field-container">
					<v-text-field
						v-model="search"
						label="Search column"
						append-icon="mdi-magnify"
						hide-details
					/>
				</div>
				<div class="field-lists-container d-flex">
					<div class="col-5 hidden-list">
						<v-list dense>
							<v-subheader>Hidden columns</v-subheader>
							<v-list-item-group
								v-model="selectedHiddenIds"
								active-class="primary white--text"
								class="field-list"
								multiple
							>
								<v-list-item
									v-for="column in localHiddenColumns"
									:key="column.Id"
									:value="column.Id"
								>
									<v-list-item-content>
										<v-list-item-title>{{
											column.Label
										}}</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</v-list-item-group>
						</v-list>
					</div>
					<div class="d-flex flex-column justify-center col-2">
						<v-btn
							class="my-2"
							color="primary"
							outlined
							text
							@click="moveColumns(true)"
						>
							<v-icon> mdi-arrow-right </v-icon>
						</v-btn>
						<v-btn
							class="my-2"
							color="primary"
							outlined
							text
							@click="moveColumns(false)"
						>
							<v-icon> mdi-arrow-left </v-icon>
						</v-btn>
					</div>
					<div class="col-5 visible-list">
						<v-list dense>
							<v-subheader>Visible columns</v-subheader>
							<v-list-item-group
								v-model="selectedVisibleIds"
								active-class="primary white--text"
								class="field-list"
								multiple
							>
								<draggable
									v-model="localVisibleColumnsFiltered"
									@change="reorderColumn"
									handle=".draggable-handle"
								>
									<v-list-item
										v-for="column in localVisibleColumnsFiltered"
										:key="column.Id"
										:value="column.Id"
										class="px-1"
									>
										<v-list-item-content>
											<v-list-item-title>
												<v-icon
													class="draggable-handle me-3"
													small
													>mdi-reorder-horizontal</v-icon
												>
												{{ column.Label }}
											</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
								</draggable>
							</v-list-item-group>
						</v-list>
					</div>
				</div>
			</v-card-text>

			<v-divider />
			<v-card-actions>
				<v-spacer />
				<v-btn outlined text @click="$emit('close')"> Close </v-btn>
				<v-btn color="primary" @click="updateColumns">
					<v-icon class="mr-2">mdi-content-save</v-icon>
					Save
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import draggable from 'vuedraggable';
export default {
	name: 'ManageFieldsDialog',
	components: { draggable },
	props: {
		showDialog: Boolean,
		visibleColumns: Array,
		hiddenColumns: Array,
	},

	computed: {
		localHiddenColumns() {
			if (!this.hiddenColumns) return [];
			return this.hiddenColumns.filter((column) =>
				column.Label.toLowerCase().includes(this.search)
			);
		},
	},
	data() {
		return {
			search: '',
			selectedVisibleIds: [],
			selectedHiddenIds: [],
			localVisibleColumns: this.visibleColumns,
			localVisibleColumnsFiltered: this.visibleColumns,
		};
	},
	watch: {
		search(value) {
			if (!value) {
				this.localVisibleColumnsFiltered = this.localVisibleColumns;
				return;
			}
			if (!this.localVisibleColumns)
				this.localVisibleColumnsFiltered = [];
			this.localVisibleColumnsFiltered = this.localVisibleColumns.filter(
				(column) => column.Label.toLowerCase().includes(this.search)
			);
		},
	},
	methods: {
		updateColumns() {
			let columns = [
				...this.localVisibleColumns,
				...this.localHiddenColumns,
			];
			this.$emit('save', columns);
		},
		reorderColumn() {
			let order = 1;
			this.localVisibleColumnsFiltered.forEach((column) => {
				column.Order = order;
				order++;
			});
		},
		moveColumns(isVisible) {
			let selectedIdsArray = isVisible
				? 'selectedHiddenIds'
				: 'selectedVisibleIds';
			this[selectedIdsArray].map((fieldId) => {
				if (!isVisible) {
					let localItem = this.localVisibleColumns.find(
						(x) => x.Id == fieldId
					);
					let localFilteredItem =
						this.localVisibleColumnsFiltered.find(
							(x) => x.Id == fieldId
						);

					if (localItem && localFilteredItem) {
						if (localItem) {
							localItem.Order = 0;
							localItem.IsVisible = false;
							let index =
								this.localVisibleColumns.indexOf(localItem);
							if (index >= 0)
								this.localVisibleColumns.splice(index, 1);
							this.localHiddenColumns.push(localItem);
						}

						if (localFilteredItem) {
							localFilteredItem.Order = 0;
							localFilteredItem.IsVisible = false;
							let index =
								this.localVisibleColumnsFiltered.indexOf(
									localItem
								);
							if (index >= 0)
								this.localVisibleColumnsFiltered.splice(
									index,
									1
								);
						}
					}
				} else {
					let item = this.localHiddenColumns.find(
						(x) => x.Id == fieldId
					);
					if (item) {
						item.IsVisible = true;
						item.Order = this.localVisibleColumns.length + 1;
						let exists = this.localVisibleColumns.find(
							(x) => x.Id == fieldId
						);
						if (!exists) this.localVisibleColumns.push(item);
						exists = this.localVisibleColumnsFiltered.find(
							(x) => x.Id == fieldId
						);
						if (!exists)
							this.localVisibleColumnsFiltered.push(item);
						let index = this.localHiddenColumns.indexOf(item);
						if (index >= 0)
							this.localHiddenColumns.splice(index, 1);
					}
				}
			});

			if (isVisible) {
				this.selectedVisibleIds = this.selectedHiddenIds;
				this.selectedHiddenIds = [];
			} else {
				this.selectedHiddenIds = this.selectedVisibleIds;
				this.selectedVisibleIds = [];
			}
			this.selectedHiddenIds = [];
			this.selectedVisibleIds = [];
		},
	},
};
</script>
